import { BFS_CAPPED_DESCRIPTION_FIELDS } from 'modules/Inquiry/bfsDescriptionFields';
import { BFS_MAX_DESCRIPTION_LENGTH } from 'modules/Inquiry/inquiry.constants';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { useSelectedInquiryTypeSpecificValue } from 'shared/chooseSelectedInquiryTypeSpecificComponent';
import { extractNestedFieldName } from 'utils/form/getFieldName';

/**
 * Resolves the character limit a field should display a counter for, or `undefined` when the
 * field has none — which is every field except the BfS Beschreibung fields (ECBFS-2).
 *
 * This only drives the *counter*; it deliberately does not become a `maxlength` attribute, so
 * the user can still type past the limit and get the validation error the ticket asks for.
 */
export const useFieldCharacterLimit = (name: string): number | undefined => {
  const fieldName = extractNestedFieldName(name);

  return useSelectedInquiryTypeSpecificValue<number | undefined>({
    [InquiryType.bfs]: BFS_CAPPED_DESCRIPTION_FIELDS.includes(fieldName)
      ? BFS_MAX_DESCRIPTION_LENGTH
      : undefined,
    default: undefined,
  });
};
